import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLang } from '../../../../../hooks/use-lang';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { useTreeStore } from '../../../../../store/use-tree-store';
import { useTagStaffStore } from '../../../../../store/use-tag-staff-store';
import { useFormStore } from '../../../../../store/use-form-store';

export const useCreateTree = () => {
  const { t } = useLang();
  const [params] = useSearchParams();
  const id = params.get('id');

  const { fetchTree, handleResetTree, isLoadingFetch, handleResetNode } = useTreeStore();
  const { fetchBranches } = useBranchesStore();
  const { fetchTags } = useTagStaffStore();
  const { fetchFormList } = useFormStore();

  useEffect(() => {
    fetchBranches({ since_id: 0, n: 1000, customCache: true });
    fetchTags({ is_by_company: true, n: 1000, since_id: 0 });
    fetchFormList({ n: 1000, since_id: 0, is_by_company: true });
    if (id) fetchTree(id);

    return () => {
      handleResetTree();
      handleResetNode();
    };
  }, [fetchBranches, fetchTree, handleResetNode, handleResetTree, id]);

  return {
    t,
    id,
    isLoadingFetch,
  };
};
